import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Indusrtypagebanner from '../components/Indusrtypagebanner';
import Leftsidebarindustry from '../components/Leftsidebarindustry';
function It() {
  return (
    <div>
      <Header/>
    <Indusrtypagebanner/>
             <div className="service-details-section sp1">
    <div className="container">
        <div className="row">
            <Leftsidebarindustry/>

          <div className="col-lg-8">
                <div className="service-main-content heading1 padding1">
                    <h2>Information Technology (IT)</h2>
                    <div className="space16"></div>
                   
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/industry/Industry_Focus/Information_Technology_(IT).png" alt=""/>
                    </div>
                    <div className="space32"></div>
                  
                    <div className="space16"></div>
                     <p>The IT industry thrives on innovation, scalability, and speed — and so do we. At JBY Talent Acquisition & Management Private Limited, we specialize in providing highly skilled IT professionals for critical roles including software development, cybersecurity, cloud infrastructure, UI/UX design, and data analytics. </p>
                     <div className="space32"></div>
                    <p>Our talent pipeline is built to support startups, MNCs, and tech-driven enterprises looking to scale fast with the right people.  </p>
                    <div className="space16"></div>
                    <p>We understand the evolving demands of the digital landscape and match companies with candidates who are both technically proficient and culturally aligned. Whether it's remote tech teams or in-house developers, we help you build your digital workforce with precision.
                    </p>
                    <div className="space32"></div>
                  
             
                    <div className="space32"></div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
        <Footer/>
    </div>
  )
}

export default It
